<template>
  <div>
    <div v-for="position in sortedResults" :key="'position_' + position.id" class="relative search_result positions_search_result" :class="{ 'clickable-result': !show_follow_button }" @click="!show_follow_button && $emit('input', position)">
      <div class="relative">
        <div class="status_color" :style="{ 'background-color': getStatusColor(position.status) }"></div>
        <div class="search_result_content">
          <div
            v-if="position.company.id"
            dir="ltr"
            class="is-flex is-align-items-center is-justify-content-flex-end"
          >
            <a @click.stop="$emit('input', position)" v-if="show_follow_button" class="button is-info">Follow</a>
            <button @click.stop="$emit('input', position)" v-else class="button is-primary is-small select-button">
              <span class="icon">
                <i class="fas fa-check"></i>
              </span>
              <span>בחר משרה</span>
            </button>
            <div class="horizontal_space"></div>
            <b>Company: (ID: {{ position.company.id }})&nbsp;</b>
            <link-entity
              :payload="position.company"
              :additional_data="{ resource_type: 'Company' }"
            ></link-entity>
          </div>
          <div dir="ltr" class="is-flex is-align-items-center is-justify-content-flex-end">
            <b>Position: (ID: {{ position.id }}) [updated at: {{ $moment(position.updated_at).format('DD-MM-YYYY') }}] &nbsp;</b>
            <link-entity :payload="position" :additional_data="{ resource_type: 'Position' }"></link-entity>
          </div>
          <p><b>Status: </b>{{ position.status }}</p>
          <div>
            <p><b>Message:</b></p>
            <message :payload="position" :additional_data="{ resource_type: 'Position', endpoint: '/positions/', headers: 'admin_headers' }"></message>
          </div>
          <p><b>is_discrete: </b>{{ position.is_discrete }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import TimeHelper from '@/custom/classes/time_helper.js'
import Message from '@/components/Message'
export default {
  name: 'search-modal-positions',
  props: ['results', 'show_follow_button'],
  data () {
    return {
      time_helper: new TimeHelper()
    }
  },
  computed: {
    sortedResults () {
      if (this.results == undefined) {
        return []
      }
      return [...this.results].sort((a, b) => {
        const aIsHot = a.is_hot === true ? 1 : 0
        const bIsHot = b.is_hot === true ? 1 : 0

        if (bIsHot !== aIsHot) {
          return bIsHot - aIsHot
        }

        const dateA = a.active_at ? new Date(a.active_at) : new Date(0)
        const dateB = b.active_at ? new Date(b.active_at) : new Date(0)
        return dateB - dateA
      })
    }
  },
  methods: {
    getStatusColor (status) {
      if (status == 'active') {
        return 'green'
      }
      if (status == 'editing') {
        return 'orange'
      }
      return 'saddlebrown'
    }
  },
  components: {
    LinkEntity,
    Message
  }
}
</script>
<style scoped>
  .status_color{
    position: absolute;
    right: 0;
    height: 100%;
    background-color: green;
    width: 3px;
  }
  .search_result_content{
    margin-right: 20px;
  }
  .search_result {
    cursor: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .clickable-result {
    cursor: pointer !important;
    transition: background-color 0.2s ease;
  }
  .clickable-result:hover {
    background-color: #f8f9fa;
  }
  .select-button {
    font-weight: 600;
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    border: none;
    color: white;
  }
  .select-button:hover {
    background: linear-gradient(135deg, #2980b9 0%, #21618c 100%);
    transform: scale(1.05);
  }
</style>
